import React from 'react';

import Header from '../Header';

const Layout = ({ children }) => {
  console.log('window.innerWidth :', window.innerWidth);
  return (
    <>
      <main className="flex-1">{children}</main>
      {/* <div
        style={{
          width: window.innerWidth > 770 ? 160 : window.innerWidth < 600 ? 468 : 728,
          height: window.innerWidth > 770 ? 600 : window.innerWidth < 600 ? 60 : 90
        }}
        className={`bg-gray-300 ${window.innerWidth > 770 ? "fixed ml-8" : "mb-12 mx-auto"} left-0 top-0 mt-8 shadow-md z-50`}
      ></div> */}
      <Header />
    </>
  );
};

export default Layout;
